import React from 'react';
import 'components/layouts/NonJumbotronBanner/nonJumbotronBanner.css';

const NonJumbotronBanner: React.FC = () => {
    return <div className="non-jumbotron-banner"></div>;
};

export default NonJumbotronBanner;
